<template>
    <div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">ZONE</h3>
                    </template>

                    <el-table :data="zones" v-loading="zonesLoading">
                        <el-table-column min-width="150" prop="name" label="Ime">
                            <template slot-scope="scope">
                                <span :style="{ color: scope.row.color }">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="numberOfParkings" label="Broj lokacija">
                            <template slot-scope="scope">
                                <span>{{ scope.row.numberOfParkings }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="hourPrice" label="Sat">
                            <template slot-scope="scope">
                                <span>{{ scope.row.hourPrice }} EUR {{ scope.row.phoneCode }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="dayPrice" label="Dan">
                            <template slot-scope="scope">
                                <span>{{ scope.row.dayPrice }} EUR {{ scope.row.phoneCodeDay }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="ticketPrice" label="Doplatna karta">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ticketPrice }} EUR</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="200" prop="ticketPrice" label="Doplatna karta sa popustom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ticketPriceWithDiscount }} EUR</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="180" label="Tip dnevne karte">
                            <template slot-scope="scope">
                                <span>{{ scope.row.dayTicketType === 1 ? 'Važi 24 sata' : 'Važi do kraja dana' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="90" label="Aktivna">
                            <template slot-scope="scope">
                                <span v-if="scope.row.active" style="color: #00e676;">DA</span>
                                <span v-else style="color: red;">NE</span>
                            </template>
                        </el-table-column>

                        <!-- <el-table-column min-width="180" label="Tip doplatne karte">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ticketType === 1 ? 'Važi 24 sata' : 'Važi do kraja dana' }}</span>
                            </template>
                        </el-table-column> -->

                        <el-table-column min-width="200" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <el-tooltip content="Izmeni" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" size="sm"
                                        @click="client = scope.row; editClient = true" class="btn-link">
                                        Izmeni
                                    </base-button>
                                </el-tooltip>
                                <el-tooltip content="Lokacije" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'success'" size="sm" class="btn-link"
                                        @click="navigateToPage(scope.row)">
                                        Parking lokacije
                                    </base-button>
                                </el-tooltip>

                                <el-tooltip content="Prevodi" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'info'" size="sm" class="btn-link"
                                        @click="openTranslations(scope.row)">
                                        Prevodi
                                    </base-button>
                                </el-tooltip>

                                <!-- <el-tooltip content="Obriši" effect="light" :open-delay="300" placement="top">
                                    <base-button :type="'danger'" icon size="sm" class="btn-link"
                                        @click="zone = scope.row; deletePrompt()">
                                        <i class="tim-icons icon-simple-remove"></i>
                                    </base-button>
                                </el-tooltip> -->
                            </div>
                        </el-table-column>
                    </el-table>
                </card>
            </div>


        </div>



        <modal :show.sync="translationsModal" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link"
                @click="translationsModal = false; resetTranslationForm()">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>

            <card class="stacked-form">
                <h4 slot="header" class="card-title">
                    Prevodi za zonu: <span :style="{ color: translationClient.color }">{{ translationClient.name }}</span>
                </h4>

                <el-table :data="translations" v-loading="translationsLoading">
                    <el-table-column min-width="80" prop="lang" label="Jezik">
                        <template slot-scope="scope">
                            <span>{{ scope.row.lang }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="180" prop="name" label="Naziv">
                        <template slot-scope="scope">
                            <span>{{ scope.row.name }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="140" header-align="right" align="right" label="Akcije">
                        <div slot-scope="scope" class="text-right table-actions">
                            <base-button :type="'success'" size="sm" class="btn-link"
                                @click="editTranslation(scope.row)">
                                Izmeni
                            </base-button>
                            <base-button :type="'danger'" size="sm" class="btn-link"
                                @click="deleteTranslation(scope.row)">
                                Obriši
                            </base-button>
                        </div>
                    </el-table-column>
                </el-table>

                <hr style="border-color: rgba(255,255,255,0.2);">

                <div class="row">
                    <div class="col-md-3">
                        <label class="control-label">Jezik</label>
                        <el-select v-model="translationForm.lang" placeholder="Jezik" style="width: 100%"
                            :disabled="translationForm.id != null">
                            <el-option v-for="l in languages" :key="l.code" :value="l.code" :label="l.name"></el-option>
                        </el-select>
                    </div>
                    <div class="col-md-6">
                        <base-input label="Naziv" type="text" v-model="translationForm.name" placeholder="Naziv na tom jeziku">
                        </base-input>
                    </div>
                    <div class="col-md-3">
                        <label class="control-label">&nbsp;</label><br>
                        <base-button type="primary" @click="saveTranslation()">
                            {{ translationForm.id ? 'Sačuvaj izmenu' : 'Dodaj' }}
                        </base-button>
                        <base-button v-if="translationForm.id" type="default" @click="resetTranslationForm()">
                            Otkaži
                        </base-button>
                    </div>
                </div>
            </card>
        </modal>

        <modal :show.sync="editClient" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editClient = false; client = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <card class="stacked-form" title="Kategorija">
                <form @submit.prevent>
                    <div>
                        <div class="row">
                            <div class="col-md-3">
                                <base-input label="Ime" type="text" v-model="client.name" placeholder="Ime">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Maksimalno vreme" type="text" v-model="client.maxHours"
                                    placeholder="Maksimalno vreme">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Cena po satu" type="text" v-model="client.hourPrice"
                                    placeholder="Cena po satu">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Dnevna cena" type="text" v-model="client.dayPrice"
                                    placeholder="Dnevna cena">
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <base-input label="Broj (sat)" type="text" v-model="client.phoneCode"
                                    placeholder="Broj">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Broj (dan)" type="text" v-model="client.phoneCodeDay"
                                    placeholder="Broj">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Doplatna karta" type="text" v-model="client.ticketPrice"
                                    placeholder="Doplatna karta">
                                </base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input label="Doplatna karta sa popustom" type="text"
                                    v-model="client.ticketPriceWithDiscount" placeholder="Doplatna karta sa popustom">
                                </base-input>
                            </div>

                            <div class="col-md-3">
                                <label class="control-label">Tip dnevne karte</label>
                                <el-select v-model="client.dayTicketType" placeholder="Tip dnevne karte"
                                    style="width: 100%">
                                    <el-option :value="0" label="Važi do kraja dana"></el-option>
                                    <el-option :value="1" label="Važi 24 sata"></el-option>
                                </el-select>
                            </div>

                            <div class="col-md-3">
                                <label class="control-label">Status zone</label><br>
                                <el-switch v-model="client.active" active-text="Aktivna"
                                    inactive-text="Neaktivna" active-color="#00e676"
                                    inactive-color="#ff4d4f">
                                </el-switch>
                            </div>
                            <!-- <div class="col-md-3">
                                <label class="control-label">Tip doplatne karte</label>
                                <el-select v-model="client.ticketType" placeholder="Tip doplatne karte"
                                    style="width: 100%">
                                    <el-option :value="0" label="Važi do kraja dana"></el-option>
                                    <el-option :value="1" label="Važi 24 sata"></el-option>
                                </el-select>
                            </div> -->
                            <div class="col-md-3">



                                <base-input label="Radno vreme (pon-pet)" type="text"
                                    v-model="client.workingHoursStartString" placeholder="">
                                </base-input>
                                <base-input label="" type="text" v-model="client.workingHoursEndString" placeholder="">
                                </base-input>

                            </div>

                            <div class="col-md-3">
                                <base-input label="Radno vreme (subota)" type="text"
                                    v-model="client.workingHoursStartSatString" placeholder="">
                                </base-input>
                                <base-input label="" type="text" v-model="client.workingHoursEndSatString"
                                    placeholder="">
                                </base-input>

                            </div>
                            <div class="col-md-3">
                                <base-input label="Radno vreme (nedelja)" type="text"
                                    v-model="client.workingHoursStartSunString" placeholder="">
                                </base-input>
                                <base-input label="" type="text" v-model="client.workingHoursEndSunString"
                                    placeholder="">
                                </base-input>

                            </div>
                        </div>

                    </div>
                </form>

                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                    @click="saveClient()">Sačuvaj</base-button>
                <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                    @click="editClient = false; client = {}">Odustani</base-button>
            </card>

        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem } from 'src/components';
import { TimeSelect, Table, TableColumn, Select, Option, DatePicker, Switch } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Switch.name]: Switch,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal
    },
    mounted() {
        this.getZones()
        // this.getUsers()
        // this.getEmployees()
        // this.getKiosks()
        // this.getRegions()
        // this.getRoles()
    },
    data() {
        return {
            activeName: 'first',
            zones: [],
            url: 'https://budva.scancar.org:8443/kuca',
            zone: {},
            parkingsModal: false,
            parkings: [],
            users: [],
            user: {},
            usersLoading: false,
            zonesLoading: false,
            user: {},
            editUserDialog: false,
            roles: [],
            employee: {},
            employees: [],
            employeesLoading: false,
            regions: [],
            kiosks: [],
            kiosk: {},
            kiosksLoading: false,
            client: {},
            editClient: false,
            editEmployeeDialog: false,
            editKioskDialog: false,
            editClient: false,
            translationsModal: false,
            translationsLoading: false,
            translationClient: {},
            translations: [],
            translationForm: {
                id: null,
                clientId: null,
                lang: null,
                name: null
            },
            languages: [
                { code: 'mne', name: 'Crnogorski (MNE)' },
                { code: 'en', name: 'Engleski (EN)' }
            ]
        };
    },
    methods: {
        getZones() {
            this.zonesLoading = true
            axios.get(this.url + '/client/getClients').then(result => {
                this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.zones = result.data.clients
                } else {

                }
            })
        },

        openTranslations(client) {
            this.translationClient = client
            this.resetTranslationForm()
            this.translationsModal = true
            this.getTranslations()
        },
        getTranslations() {
            this.translationsLoading = true
            axios.get(this.url + '/client/getClientTranslations?clientId=' + this.translationClient.id).then(result => {
                this.translationsLoading = false
                if (result.data.result === 'ok') {
                    this.translations = result.data.translations
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            }).catch(() => {
                this.translationsLoading = false
            })
        },
        editTranslation(t) {
            this.translationForm = {
                id: t.id,
                clientId: this.translationClient.id,
                lang: t.lang,
                name: t.name
            }
        },
        resetTranslationForm() {
            this.translationForm = {
                id: null,
                clientId: this.translationClient.id,
                lang: null,
                name: null
            }
        },
        saveTranslation() {
            if (!this.translationForm.lang) {
                this.$notify({
                    message: 'Odaberite jezik',
                    timeout: 3000,
                    icon: 'tim-icons icon-bell-55',
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: 'warning'
                });
                return
            }
            if (!this.translationForm.name || !this.translationForm.name.trim()) {
                this.$notify({
                    message: 'Unesite naziv',
                    timeout: 3000,
                    icon: 'tim-icons icon-bell-55',
                    horizontalAlign: "right",
                    verticalAlign: "top",
                    type: 'warning'
                });
                return
            }
            this.translationForm.clientId = this.translationClient.id
            axios.post(this.url + '/client/saveClientTranslation', this.translationForm).then(result => {
                if (result.data.result === 'ok') {
                    this.$notify({
                        message: 'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-check-2',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.resetTranslationForm()
                    this.getTranslations()
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        deleteTranslation(t) {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Obrisati prevod (" + t.lang + ")?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        axios.post(this.url + '/client/deleteClientTranslation', { id: t.id }).then(res => {
                            if (res.data.result === 'ok') {
                                this.getTranslations()
                            } else {
                                this.$notify({
                                    message: res.data.reason,
                                    timeout: 3000,
                                    icon: 'tim-icons icon-bell-55',
                                    horizontalAlign: "right",
                                    verticalAlign: "top",
                                    type: 'danger'
                                });
                            }
                        })
                    }
                });
        },

        saveClient() {
            this.loading = true
            axios.post(this.url + '/client/saveClient', this.client).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editClient = false
                    this.client = {}
                    this.getZones()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },

        navigateToPage(zone) {
            this.$router.push({ name: 'ZoneParkings', params: { id: zone.id } });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da obrišete zonu \"" + this.zone.name + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {

                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        }
    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>